import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

// Loads GA4 only when a Measurement ID is configured in Admin → Settings → SEO & Analytics.
// Sends a page_view on load and on every SPA route change.
export default function Analytics() {
  const { pathname } = useLocation();
  const ready = useRef(false);
  const lastTracked = useRef(null);

  const track = (path) => {
    if (!window.gtag) return;
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
    lastTracked.current = path;
  };

  useEffect(() => {
    api.get("/config/analytics").then(({ data }) => {
      const id = (data?.ga_id || "").trim();
      if (!id || document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${id}"]`)) return;
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag("js", new Date());
      window.gtag("config", id, { send_page_view: false });
      ready.current = true;
      track(window.location.pathname);
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!ready.current || lastTracked.current === pathname) return;
    // Let <Seo> update document.title before the hit is sent.
    const t = setTimeout(() => track(pathname), 300);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return null;
}
